// fields we request from API
export enum ApiSelectFields {
    TAGS                = 'tags',
    TIME_REPORTS        = 'timeReports',
    TASK_USERS          = 'taskUsers',
    PROJECT_DEADLINES   = 'projectDeadlines',
    PREDECESSORS        = 'predecessors',
    SUCCESSORS          = 'successors',
    DESCRIPTION         = 'description',
    TODO_LIST           = 'todoList',
    MESSAGES_TOTAL      = 'messagesTotal',
    ATTACHMENTS_TOTAL   = 'attachmentsTotal',
    PROJECT_USERS       = 'projectUsers',
    CRM                 = 'crm',
    EXPENSES            = 'expenses',
    TASKS_TOTALS        = 'taskTotals',      // project open/closed totals

    COST                = 'cost',
    TASKS               = 'tasks',          // for Portfolio
}

export enum UniversalTaskSelectorMode {
    PROJECT_VIEW    = 'project-view',
    CUSTOM_VIEW     = 'custom-view',
    SHARED_VIEW     = 'shared-view'
}

export enum ApiSystemStatus {
    ALL         = 'all',
    OPEN        = 'open',
    CLOSED      = 'closed',
}

export type UniversalTaskSelector_columnField = {
    type    : string
    id      : ID
}